import { render, staticRenderFns } from "./TabelaPercentual.vue?vue&type=template&id=d75de4a2&scoped=true"
import script from "./TabelaPercentual.vue?vue&type=script&lang=js"
export * from "./TabelaPercentual.vue?vue&type=script&lang=js"
import style0 from "./TabelaPercentual.vue?vue&type=style&index=0&id=d75de4a2&prod&lang=css"
import style1 from "./TabelaPercentual.vue?vue&type=style&index=1&id=d75de4a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d75de4a2",
  null
  
)

export default component.exports